export default __webpack_public_path__ + "static/media/scenario-a-progress.42c8151f.png";